import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  ContactUsChatPage,
  ContactUsEmailPage,
  ContactUsPage,
  FaqDesktopLayout,
  FaqMobiLayout,
  LeftNavLayout,
  MainContentPage,
  MobiNavPage,
  MobiSubCategoryPage,
  MobiTopicPage,
  SearchResultsPage,
} from 'modules/pages';
import { SiteDataContext } from 'App';
import { useWindowSize } from 'modules/hooks';
import { FAQ_CONSTANTS } from 'modules/constants';
import DeeplinkPageContainer from 'modules/pages/MainContentPage/DeeplinkPageContainer';
import { DeeplinkTopicPage } from 'modules/pages/MobiTopicPage';

const { CONTACT_US_ID } = FAQ_CONSTANTS;

export const DESKTOP_MIN = 812;

function Router() {
  const { handle } = useContext(SiteDataContext);
  const [width] = useWindowSize();

  return width > DESKTOP_MIN ? (
    <FaqDesktopLayout handle={handle}>
      <Switch>
        <Route
          path="/search"
          render={() => (
            <LeftNavLayout activeCategoryId={-1}>
              <SearchResultsPage />
            </LeftNavLayout>
          )}
        />
        <Route
          exact
          path="/contact-us"
          render={() => (
            <LeftNavLayout activeCategoryId={CONTACT_US_ID}>
              <ContactUsPage />
            </LeftNavLayout>
          )}
        />
        <Route
          path="/contact-us/chat"
          render={() => (
            <LeftNavLayout activeCategoryId={CONTACT_US_ID}>
              <ContactUsChatPage />
            </LeftNavLayout>
          )}
        />
        <Route
          path="/contact-us/email"
          render={() => (
            <LeftNavLayout activeCategoryId={CONTACT_US_ID}>
              <ContactUsEmailPage />
            </LeftNavLayout>
          )}
        />
        <Route path="/faq/:deeplink?" render={(props) => <DeeplinkPageContainer {...props} />} />
        <Route path="/:categoryId?/:topicId?" render={(props) => <MainContentPage {...props} />} />
      </Switch>
    </FaqDesktopLayout>
  ) : (
    <FaqMobiLayout handle={handle}>
      <Switch>
        <Route exact path="/" render={() => <MobiNavPage />} />
        <Route exact path="/search" render={() => <SearchResultsPage />} />
        <Route exact path="/contact-us" render={() => <ContactUsPage />} />
        <Route path="/contact-us/chat" render={() => <ContactUsChatPage />} />
        <Route path="/contact-us/email" render={() => <ContactUsEmailPage />} />
        <Route exact path="/:categoryId" render={(props) => <MobiSubCategoryPage {...props} />} />
        <Route path="/faq/:deeplink?" render={(props) => <DeeplinkTopicPage {...props}/>} />
        <Route path="/:categoryId/:topicId" render={(props) => <MobiTopicPage {...props} />} />
      </Switch>
    </FaqMobiLayout>
  );
}

export default Router;
